import { render, staticRenderFns } from "./fieldtype_date.vue?vue&type=template&id=f1860eae&scoped=true&"
import script from "./fieldtype_date.vue?vue&type=script&lang=js&"
export * from "./fieldtype_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1860eae",
  null
  
)

export default component.exports